import React from 'react';
import { useLocation, Redirect } from 'react-router-dom';
import { Card, Button, Result } from 'antd';

import { LayoutPage } from 'components/layouts';

import { useAuthState } from 'react-firebase-hooks/auth';
import Client from 'containers/app/client';

import './style.css';

const ConfirmationSent = () => {
  const location = useLocation();
  const [user, loading, error] = useAuthState(Client.auth);
  if (loading) return 'loading...';
  if (error) throw error;

  const { email, emailVerified } = user;

  if (emailVerified)
    return <Redirect to={{ pathname: '/', state: { from: location } }} />;

  return (
    <LayoutPage className="email-confirmation-sent-page">
      <LayoutPage.Container className="wrapper">
        <Card>
          <Result
            status="success"
            title="Verification email has been sent!"
            subTitle={`Check your inbox at ${email}`}
            extra={[
              <Button
                key="buy"
                onClick={() => {
                  Client.sendEmailVerification();
                }}
              >
                Send verification email again
              </Button>,
            ]}
          />
        </Card>
      </LayoutPage.Container>
    </LayoutPage>
  );
};

ConfirmationSent.propTypes = {};
ConfirmationSent.defaultProps = {};

export default ConfirmationSent;
